export default __webpack_public_path__ + "static/media/milestone-progress-bar.3325907b.svg";